// extracted by mini-css-extract-plugin
export default {"wrapper":"AsyncStaticPage_wrapper__1yos9"};